<template>
  <div class="container-search">
    <el-dialog
      :visible.sync="dialogVisible"
      title="搜索"
      width="650px"
      class="search-dialog"
      @close="handleDialogClose"
    >
      <div class="input-wrap mwow-form">
        <el-input
          v-model="searchInfo.keyword"
          placeholder="请输入关键字"
          prefix-icon="el-icon-search"
          @change="handleSearch"
          ref="dialogInput"
        ></el-input>
      </div>
      <div class="content-tabs">
        <el-tabs v-model="activeName" @tab-click="handleSearch">
          <el-tab-pane label="全部" name="all">
            <div class="no-data" v-show="searchResult.length === 0">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/search-nodata.png"
              />
              <span class="text">暂无数据</span>
            </div>
            <div class="content-wrap">
              <div
                class="content-item"
                v-for="(item, index) in searchResult"
                :key="index"
                @click="toPosition(item)"
              >
                <div class="flex item-top">
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/directory.png"
                    width="12px"
                    class="item-icon"
                    v-show="item.search_type === 'doc'"
                  />
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/folder.png"
                    width="15px"
                    height="14px"
                    class="item-icon"
                    v-show="item.search_type === 'dir'"
                  />
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/attach1.png"
                    width="14px"
                    class="item-icon"
                    v-show="item.search_type === 'attach'"
                  />
                  <div class="item-title">{{ item.name }}</div>
                </div>
                <div class="item-bottom">
                  <span>文件位置：</span>
                  <span v-for="(item, index) in item.position" :key="index">
                    <i
                      class="el-icon-arrow-right arrow"
                      v-show="index !== 0"
                      style="margin: 0 4px"
                    ></i>
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="文章" name="article">
            <div class="no-data" v-show="searchResult.length === 0">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/search-nodata.png"
              />
              <span class="text">暂无数据</span>
            </div>
            <div class="content-wrap">
              <div
                class="content-item"
                v-for="(item, index) in searchResult"
                :key="index"
                @click="toPosition(item)"
              >
                <div class="flex item-top">
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/directory.png"
                    width="12px"
                    class="item-icon"
                  />
                  <div class="item-title">{{ item.name }}</div>
                </div>
                <div class="item-bottom">
                  <span>文件位置：</span>
                  <span v-for="(item, index) in item.position" :key="index">
                    <i
                      class="el-icon-arrow-right arrow"
                      v-show="index !== 0"
                      style="margin: 0 4px"
                    ></i>
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="附件" name="annex">
            <div class="no-data" v-show="searchResult.length === 0">
              <img
                class="icon"
                src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/search-nodata.png"
              />
              <span class="text">暂无数据</span>
            </div>
            <div class="content-wrap annex-wrap mwow-form">
              <div
                class="content-item"
                v-for="(item, index) in searchResult"
                :key="index"
              >
                <div class="flex item-top">
                  <el-checkbox
                    v-model="item.checked"
                    style="margin-right: 8px"
                  ></el-checkbox>
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/attach1.png"
                    width="14px"
                    class="item-icon"
                  />
                  <div class="item-title" @click="toPosition(item)">
                    {{ item.name }}
                  </div>
                </div>
                <div class="item-bottom">
                  <span>文件位置：</span>
                  <span v-for="(item, index) in item.position" :key="index">
                    <i
                      class="el-icon-arrow-right arrow"
                      v-show="index !== 0"
                      style="margin: 0 4px"
                    ></i>
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
            </div>
            <div class="flex annex-bottom mwow-form">
              <el-checkbox
                v-model="isSelectAll"
                @change="handleSelectAll"
              ></el-checkbox>
              <div class="annex-selected">
                <span style="margin-right: 10px">全选</span>
                已选
                <span class="color-69">{{ selectedNumber }}</span>
                项
              </div>
              <div
                class="annex-download"
                @click="handleDownload"
                v-debounce="1000"
              >
                批量下载
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="目录" name="category">
            <div class="content-wrap">
              <div class="no-data" v-show="searchResult.length === 0">
                <img
                  class="icon"
                  src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/search-nodata.png"
                />
                <span class="text">暂无数据</span>
              </div>
              <div
                class="content-item"
                v-for="(item, index) in searchResult"
                :key="index"
                @click="toPosition(item)"
              >
                <div class="item-bottom">
                  <img
                    src="https://wowsite.musicwow.com/teaching_system_frontend/images/wowLibrary/folder.png"
                    width="15px"
                    height="14px"
                    style="margin-right: 6px"
                  />
                  <span>文件位置：</span>
                  <span v-for="(item, index) in item.position" :key="index">
                    <i
                      class="el-icon-arrow-right arrow"
                      v-show="index !== 0"
                      style="margin: 0 4px"
                    ></i>
                    <span>{{ item.name }}</span>
                  </span>
                </div>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { handleSearchApi, handleDocDownloadAddApi } from "@/api/wow";
export default {
  props: ["visible"],
  name: "",
  data() {
    return {
      searchInfo: {
        keyword: "",
      },
      activeName: "all",
      dialogVisible: false,
      searchResult: [],
      isSelectAll: false,
    };
  },
  watch: {
    visible(n) {
      if (n) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.dialogInput.focus();
        });
      } else {
        this.activeName = "all";
        this.searchInfo.keyword = "";
        this.searchResult = [];
        this.isSelectAll = false;
      }
    },
  },
  computed: {
    selectedNumber() {
      return this.searchResult.filter((item) => {
        return item.checked;
      }).length;
    },
  },
  methods: {
    handleSearch() {
      if (!this.searchInfo.keyword) {
        return false;
      }
      this.searchResult = [];
      let type = "";
      if (this.activeName === "article") {
        type = "doc";
      }
      if (this.activeName === "category") {
        type = "dir";
      }
      if (this.activeName === "annex") {
        type = "attach";
      }
      handleSearchApi({
        search_type: type,
        key_word: this.searchInfo.keyword,
      }).then((res) => {
        if (res.error_code === 0) {
          if (this.activeName === "annex") {
            res.data.list.map((item) => {
              item.checked = false;
            });
          }
          this.searchResult = res.data.list;
        }
      });
    },
    handleDownload() {
      let selected = this.searchResult.filter((item) => {
        return item.checked;
      });
      if (selected.length === 0) {
        this.$message({
          message: "请先选择附件",
          type: "warning",
        });
        return false;
      }
      handleDocDownloadAddApi({
        file_list: selected.map((a) => {
          return {
            doc_id: a.attach.doc_id,
            file_uuid: [a.attach.file_uuid],
          };
        }),
      });
      selected.map((attach) => {
        fetch(attach.file_link)
          .then((res) => res.blob())
          .then((blob) => {
            const a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = attach.name;
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
          });
      });
    },
    handleSelectAll(v) {
      this.searchResult.map((item) => {
        item.checked = v;
      });
    },
    toPosition(data) {
      let params = {
        catalog_uuid: data.catalog_uuid,
        type: data.search_type,
      };
      if (data.search_type === "attach") {
        params.attach_uuid = data.attach.file_uuid;
      }
      this.$emit("change", params);
      this.dialogVisible = false;
    },
    handleDialogClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    },
  },
};
</script>
<style lang="scss" scoped>
.container-search {
  /deep/ .search-dialog {
    .el-dialog__body {
      padding: 15px 0 0 0 !important;
      .input-wrap {
        padding: 0 20px;
      }
      .content-tabs {
        .el-tabs__header {
          padding: 0 20px !important;
          margin: 0 !important;
          .el-tabs__nav-wrap::after {
            background: transparent !important;
          }
          .el-tabs__nav {
            .el-tabs__active-bar {
              background: rgba(69, 177, 59, 1) !important;
              border: none !important;
            }
            .is-active {
              color: rgba(69, 177, 59, 1) !important;
            }
            .el-tabs__item:hover {
              color: rgba(69, 177, 59, 1) !important;
            }
          }
        }
        .el-tabs__content {
          padding: 25px 32px !important;
          background: rgba(247, 250, 252, 1);
          position: relative;
          .el-tab-pane {
            .content-wrap {
              max-height: 400px;
              overflow: hidden auto;
              &::-webkit-scrollbar {
                width: 4px;
              }
              &::-webkit-scrollbar-track {
                width: 4px;
                background: none;
              }
              &::-webkit-scrollbar-thumb {
                width: 4px;
                background: #d8d8d8;
              }
              .content-item {
                margin-bottom: 25px;
                cursor: pointer;
                .item-top {
                  margin-bottom: 12px;
                  font-size: 13px;
                  color: #5c5d5e;
                  display: flex;
                  align-items: center;
                  .item-title {
                    margin-left: 10px;
                  }
                }
                .item-bottom {
                  margin-left: 24px;
                  font-size: 12px;
                  color: #9c9e9e;
                }
                &:nth-last-child(1) {
                  margin-bottom: 0 !important;
                }
              }
            }
            .annex-wrap {
              max-height: 400px;
              overflow: hidden auto;
              margin-bottom: 40px;
              &::-webkit-scrollbar {
                width: 4px;
              }
              &::-webkit-scrollbar-track {
                width: 4px;
                background: none;
              }
              &::-webkit-scrollbar-thumb {
                width: 4px;
                background: #d8d8d8;
              }
              .annex-item {
                align-items: flex-start !important;

                .annex-right {
                  margin-left: 12px;
                }
                &:nth-last-child(1) {
                  margin-bottom: 0 !important;
                }
              }
            }
            .annex-bottom {
              position: absolute;
              bottom: 20px;
              .annex-selected {
                margin: 0 25px 0 10px;
                font-size: 14px;
              }
              .annex-download {
                border: 1px solid rgba(92, 93, 94, 1);
                border-radius: 5px;
                padding: 5px 10px;
                cursor: pointer;
              }
              .el-checkbox {
                .is-checked {
                  .el-checkbox__inner {
                    background: rgba(69, 177, 59, 1);
                    border-color: rgba(69, 177, 59, 1);
                  }
                }
                .el-checkbox__inner:hover {
                  border-color: rgba(69, 177, 59, 1) !important;
                }
              }
            }
          }
        }
      }
    }
  }
}
.flex {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.color-69 {
  color: rgba(69, 177, 59, 1);
}

/deep/ .el-checkbox {
  .is-checked {
    .el-checkbox__inner {
      background: rgba(69, 177, 59, 1);
      border-color: rgba(69, 177, 59, 1);
    }
  }
  .el-checkbox__inner:hover {
    border-color: rgba(69, 177, 59, 1) !important;
  }
}
.no-data {
  margin: 110px auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  .icon {
    width: 27px;
    margin-right: 15px;
  }
  .text {
    font-size: 13px;
    color: #5c5d5e;
  }
}
</style>
